import { getFirestore, collection, query, orderBy, limit, getDocs } from "firebase/firestore";

export const useActivityLogService = () => {
  const db = getFirestore(); // Ensure Firebase is initialized

  return {
    async getRecentActivity() {
      try {
        const q = query(collection(db, "activity_logs"), orderBy("timestamp", "desc"), limit(10));
        const snapshot = await getDocs(q);
        return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      } catch (error) {
        console.error("Error fetching recent activity:", error);
        throw error;
      }
    }
  };
};